import { CloseOutlined } from "@ant-design/icons";
import { Alert, Button, Typography } from "antd";
import { Fragment } from "react";
import VersionList, { handleCloseRestoreView } from "viewer/view/version_list";

function VersionView() {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
      }}
    >
      <div
        style={{
          flex: "0 1 auto",
          padding: "0px 5px",
        }}
      >
        <Typography.Title
          level={4}
          style={{
            display: "inline-block",
            marginLeft: 4,
          }}
        >
          Version History
        </Typography.Title>
        <Button
          className="close-button"
          style={{
            float: "right",
            border: 0,
          }}
          onClick={handleCloseRestoreView}
          shape="circle"
          icon={<CloseOutlined />}
        />
        <div
          style={{
            fontSize: 12,
            marginBottom: 8,
          }}
        >
          <Alert
            type="info"
            title={
              <Fragment>
                You are currently previewing older versions of this annotation. Either restore a
                version by selecting it or close this view to continue annotating. The shown
                annotation is in <b>read-only</b> mode as long as this view is opened.
              </Fragment>
            }
          />
        </div>
      </div>
      <div
        style={{
          flex: "1 1 auto",
          overflowY: "auto",
          paddingLeft: 2,
        }}
      >
        <VersionList />
      </div>
    </div>
  );
}

export default VersionView;
